import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

function SafeHtml({ className, html }) {
  return <div className={className} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html || '') }} />;
}

SafeHtml.propTypes = {
  className: PropTypes.string,
  html: PropTypes.string,
};

SafeHtml.defaultProps = {
  className: undefined,
  html: '',
};

export default SafeHtml;
